import useMessage from '@rottitime/react-hook-message-event';
import { createContext, ReactNode, useContext } from 'react';
import { toast, ToastContainer, ToastOptions } from 'react-toastify';

import { IoMdInformationCircleOutline } from "react-icons/io"

const ToastContext = createContext<{
    success: (message: string, config?: ToastOptions<unknown>) => void,
    error: (message: string, config?: ToastOptions<unknown>) => void,
    info: (message: string, config?: ToastOptions<unknown>) => void,
    warning: (message: string, config?: ToastOptions<unknown>) => void,
}>({
    success: () => { },
    error: () => { },
    info: () => { },
    warning: () => { },
});

export const useToastify = () => useContext(ToastContext)

import "react-toastify/dist/ReactToastify.css";
import { JsChannelKeys } from 'src/constants/JsChannelKeys';
import { FaRegCircleCheck } from 'react-icons/fa6';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { LuCircleAlert } from 'react-icons/lu';
import styled from 'styled-components';

export const ToastProvider = (props: { children: ReactNode }) => {
    useMessage(JsChannelKeys.ALERT, (_, payload) => {
        const message = (payload.message ?? "") as string;

        if(message == 'Request failed with status code 401')
            return;

        switch (payload.typeAlert) {
            case "success":
                toast.success(CustomToast(message, payload.typeAlert));
                break;
            case "error":
                toast.error(CustomToast(message, payload.typeAlert));
                break;
            case "info":
                toast.info(CustomToast(message, payload.typeAlert));
                break;
            case "warning":
                toast.warn(CustomToast(message, payload.typeAlert));
                break;
        }
    });

    function CustomToast(title: string, message: string, type: string) {
        return (
            <div className='column' style={{ marginLeft: 15 }}>
                <Title className={type}>{title}</Title>
                <span>{message}</span>
            </div>
        )
    }


    return (
        <ToastContext.Provider value={{
            success: (message: string, config?: ToastOptions<unknown>) => toast.success((CustomToast('Sucesso', message, 'success')), config),
            info: (message: string, config?: ToastOptions<unknown>) => toast.info((CustomToast('Informação', message, 'info')), config),
            warning: (message: string, config?: ToastOptions<unknown>) => toast.warn((CustomToast('Atenção', message, 'warning')), config),
            error: (message: string, config?: ToastOptions<unknown>) => {
                if(message == 'Request failed with status code 401')
                    return;
                
                toast.error((CustomToast('Erro', message, 'error')), config)
            },
        }}>
            {props.children}
            <ToastContainer
                style={{ zIndex: 11000 }}
                hideProgressBar
                icon={({ type }) => {
                    switch (type) {
                        case 'success':
                            return (
                                <ContainerIcon className={type}>
                                    <FaRegCircleCheck />
                                </ContainerIcon>
                            )
                        case 'error':
                            return (
                                <ContainerIcon className={type}>
                                    <IoCloseCircleOutline />
                                </ContainerIcon>
                            )
                        case 'warning':
                            return (
                                <ContainerIcon className={type}>
                                    <LuCircleAlert />
                                </ContainerIcon>
                            )
                        case 'info':
                            return (
                                <ContainerIcon className={type}>
                                    <IoMdInformationCircleOutline />
                                </ContainerIcon>
                            )
                        default:
                            return null;
                    }
                }}
            />
        </ToastContext.Provider>
    )
}

const Title = styled.strong`
    &.success {
        color: ${({theme}) => theme.palette.success.main};
    }

    &.error {
        color: ${({theme}) => theme.palette.error.main};
    }

    &.warning {
        color: ${({theme}) => theme.palette.warning.main};
    }

    &.info {
        color: ${({theme}) => theme.palette.info.main};
    }
`

const ContainerIcon = styled.div`
    padding: 10px 10px 6px 10px;
    border-radius: 8px;
    color: ${({ theme }) => theme.palette.neutral[400]};

    &.success {
        background-color: ${({ theme }) => theme.palette.success.main};
    }

    &.error {
        background-color: ${({ theme }) => theme.palette.error.main};
    }

    &.warning {
        background-color: ${({ theme }) => theme.palette.warning.main};
    }

    &.info {
        background-color: ${({ theme }) => theme.palette.info.main};
    }
`